import React from 'react'
import styled, { css } from 'react-emotion'
import Link from 'redux-first-router-link'
import LegacyLink from 'components/LegacyLink'
import { normalizeCount } from 'util/favicon'

import themeVars from 'ui_theme/site/globals/site.variables'
import { SVGIcon, Tooltip } from 'shared/ui'

const GlobalNavItemContainer = styled('div')`
  color: ${({ isActive }) =>
    isActive ? themeVars.groovy : themeVars.ultraLight};
  transition: all 150ms ease-in-out;
  line-height: 0;
  &:hover {
    background-color: ${({ isActive }) =>
      isActive ? '' : themeVars.ultraDust};
  }
  > div > a:before {
    display: ${({ noticeCount }) => (noticeCount ? 'block' : 'none')};
    content: "${({ noticeCount }) => noticeCount}";
  }
`

const IconLink = css`
  display: block;
  padding: 12px 16px;
  cursor: pointer;

  && {
    color: inherit !important;
  }

  &:before {
    position: absolute;
    top: 3px;
    right: 3px;
    background: ${themeVars.newBerry};
    border: solid 2px ${themeVars.white};
    border-radius: 8px;
    height: auto;
    font-size: 8px;
    color: ${themeVars.white};
    line-height: 1;
    text-align: center;
    padding: 2px;
    min-width: 16px;
    font-family: ${themeVars.graphik};
  }
`

export default function GlobalNavItem({
  color,
  iconName,
  isActive,
  onClick,
  isLegacy,
  to,
  title,
  size = 16,
  tooltipDisabled = false,
  noticeCount = 0,
}) {
  return (
    <GlobalNavItemContainer
      color={color}
      data-test-id={title}
      isActive={isActive}
      onClick={onClick}
      noticeCount={normalizeCount(noticeCount)}
    >
      <Tooltip position="right" tooltip={title} disabled={tooltipDisabled}>
        {!to && (
          <div className={IconLink}>
            <SVGIcon name={iconName} size={size} />
          </div>
        )}
        {to &&
          isLegacy && (
            <LegacyLink path={to} className={IconLink}>
              <SVGIcon name={iconName} size={size} />
            </LegacyLink>
          )}
        {to &&
          !isLegacy && (
            <Link to={to} className={IconLink}>
              <SVGIcon name={iconName} size={size} />
            </Link>
          )}
      </Tooltip>
    </GlobalNavItemContainer>
  )
}
